<script>
  import { fly } from "svelte/transition";

  export let index, sub;

  const { contents, title, caption, status } = sub;
</script>

<div on:click in:fly={{ y: 20, delay: 150 * index + 300 }} class="submission noblue">
  <div class="image">
    {#if contents.length > 1}
      <svg class="count" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="images" role="img" viewBox="0 0 576 512"><path fill="currentColor" d="M480 416v16c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48V176c0-26.51 21.49-48 48-48h16v208c0 44.112 35.888 80 80 80h336zm96-80V80c0-26.51-21.49-48-48-48H144c-26.51 0-48 21.49-48 48v256c0 26.51 21.49 48 48 48h384c26.51 0 48-21.49 48-48zM256 128c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-96 144l55.515-55.515c4.686-4.686 12.284-4.686 16.971 0L272 256l135.515-135.515c4.686-4.686 12.284-4.686 16.971 0L512 208v112H160v-48z" class=""></path></svg>
    {/if}
    {#if contents[0].contentType == 'image'}
      <img src={contents[0].content} alt="" />
    {:else}
      <video width="80" height="80" controls>
        <track kind="captions" />
        <source src={contents[0].content} type="video/mp4">
        Your browser does not support the video tag.
      </video>
    {/if}
  </div>
  <div class="content">
    <h2 class="sub-title">{title}</h2>
    {#if caption}
      <p class="sub-caption">{caption}</p>
    {/if}
  </div>
  <div class="actions">
    <span class="status {status}">{sub.status == 'review'? 'in review' : sub.status}</span>
  </div>
</div>

<style>
  .submission {
    display: flex;
    position: relative;
    background: #fff;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    gap: 1rem;
    box-sizing: border-box;
    cursor: pointer
  }
  .submission:hover {
    box-shadow: 0 0 0 1px #58cfeb;
  }
  .sub-title {
    margin: 0;
    font-size: 1.1rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
  }
  .sub-caption {
    margin: 0;
    margin-top: 0.5rem;
    font-size: 0.95rem;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  .count {
    position: absolute;
    top: 0;
    left: 0;
    margin: 4px;
    height: 1rem;
    width: 1rem;
    color: #58cfeb;
    fill: currentColor
  }

  .image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    display: flex;
    align-items: center;
    position: relative;
  }

  .image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.5rem;
  }
  .image video {
    border-radius: 0.5rem;
  }

  .content {
    flex: 1;
    text-align: left;
  }
  .actions {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .status {
    background-color: #efefef;
    border-radius: 999px;
    font-size: .95rem;
    padding: .25rem .45rem
  }
  .submitted {
    background-color: rgb(179, 255, 163)
  }
  .review {
    background-color: rgb(163, 252, 255)
  }
  .approved {
    background-color: rgb(179, 255, 163)
  }
  .denied {
    background-color: rgb(255, 194, 194)
  }
  .posted {
    color: #fff;
    background: radial-gradient(circle at -20% 180%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 90%);
  }
</style>
